module.exports = __webpack_public_path__ + "img/color_block_6.5e9460ea.svg";